import { CheckCircle, XCircle } from 'lucide-react';

const Item = ({ ok, label, testId }) => (
  <span className="flex items-center gap-1.5 text-xs" data-testid={testId}>
    {ok ? <CheckCircle className="w-3.5 h-3.5 text-green-600" /> : <XCircle className="w-3.5 h-3.5 text-red-500" />}
    {label}
  </span>
);

export const WebhookStatusBar = ({ status }) => {
  if (!status) return null;
  const url = `${window.location.origin}${status.callback_path}`;
  return (
    <div className="flex flex-wrap items-center gap-x-5 gap-y-2 px-4 py-3 rounded-xl border border-border bg-muted/30" data-testid="inbox-webhook-status">
      <span className="text-xs text-muted-foreground">Callback URL: <code className="font-mono text-foreground">{url}</code></span>
      <Item ok={status.verify_token_configured} label="Verify token" testId="inbox-status-verify-token" />
      <Item ok={status.app_secret_configured} label="App secret" testId="inbox-status-app-secret" />
      <span className="text-xs text-muted-foreground">
        Last inbound: {status.last_inbound_at ? new Date(status.last_inbound_at).toLocaleString() : 'none yet'}
      </span>
    </div>
  );
};
